import { render, staticRenderFns } from "./NotificationsAlbum.vue?vue&type=template&id=53421542&"
import script from "./NotificationsAlbum.vue?vue&type=script&lang=js&"
export * from "./NotificationsAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports